

import React from 'react';
import { Card as BSCard, CardBody, CardHeader } from 'reactstrap';
import ListLoad, { CreateButton } from '../base/components/ListLoad';
import { getNavContext } from '../base/components/NavBar';
import PropControl from '../base/components/PropControl';
import KStatus from '../base/data/KStatus';
import DataStore from '../base/plumbing/DataStore';
import SearchQuery from '../base/searchquery';
import { article, commaList, uniq } from '../base/utils/miscutils';
import C from '../C';
import { keyForType } from '../base/plumbing/Crud';
import ActionMan from '../plumbing/ActionMan';

/**
 * List advertiser offspring items, like Advert
 * 
 * @param {Object} p
 * @param {TYPES[]} p.createWith E.g. ["Advertiser"]. The type(s) of "parent" object that must be in-focus to create a new object of this list's type
 * (eg an Advertiser must be focused to create an Advert). Use setNavContext() -- see AdvertiserPage.jsx for an example.
 * This ALSO gets added to the list query as filters.
 * @param {TYPES[]} p.filterWith like createWith but just the filtering part
 * @param {?JSX} p.FilterControls HACK allows custom filter controls to be provided. Use with `filterFn`
 * @param {?boolean} p.canCreate If false, no create button for you (use something else e.g. monday.com)
 * @param {?string} p.pageSelectID Get the page (1-indexed) from the url using this parameter
 */
function ListItems({type, createWith, filterWith, createHelp, ListItem, FilterControls=DefaultFilterControls, filterFn, 
	canCreate=true, canDelete=true, pageSize, pageSelectID}) 
{
	let q = DataStore.getUrlValue('q');
	// heading
	let heading = q? `${type}s for "${q}"` : `All ${type}s`;
	// HACK add base params to q (e.g. filter by advertiser)
	if (createWith || filterWith) {
		// add to any query
		let sq = new SearchQuery(q);
		let fwith = uniq((createWith||[]).concat((filterWith||[]))); // sorry for the ugly handling of potential nulls
		fwith.forEach(t => {
			let tid = getNavContext(t);
			let k = keyForType(t);
			sq = SearchQuery.setProp(sq, k, tid);
		});
		q = sq.query; 
		// modify heading
		let headingFrom = "";
		fwith.forEach(t => {
			let tid = getNavContext(t);
			if ( ! tid) {
				return;
			}
			let pvAdvertiser = ActionMan.getDataItem({type:t, id:tid, status:KStatus.PUB_OR_DRAFT});
			let advertiserName = (pvAdvertiser && pvAdvertiser.value && pvAdvertiser.value.name) || tid;
			headingFrom += " "+t+" "+advertiserName;
		});
		if (headingFrom) heading+= " from "+headingFrom;
	}

	const filter = DataStore.getUrlValue("filter");

	return (<BSCard><CardHeader>{heading}</CardHeader>
		<CardBody>
			{canCreate? <CreateAdThingButton type={type} createWith={createWith} /> : createHelp}
			{FilterControls && <FilterControls />}
			<ListLoad type={type} q={q} filter={filter} filterFn={filterFn} 
				canCreate={false} canDelete={canDelete} canCopy={canCreate} 
				status={KStatus.ALL_BAR_TRASH} ListItem={ListItem} pageSize={pageSize} pageSelectID={pageSelectID}/>
		</CardBody>
	</BSCard>);
}


/**
 * @param {Object} p
 * @param {TYPES} p.types Type of object to create
 * @param {TYPES[]} p.createWith List of has-a types to be put on the new item - all must be in-context to create.
 * @param {?String} p.navpage Switch to this page to view/edit the new item on creation.
 * @param {React.Element|String} p.children Button contents
 * @returns 
 */
export function CreateAdThingButton({type, createWith, navpage, children}) {
	// Simple - doesn't need has-a fields set up.
	if (!createWith) return <CreateButton type={type} />;

	let base = {};
	// HACK fill in the base, e.g. Adverts have a `vertiser` property
	for (let i = 0; i < createWith.length; i++) {
		let cwType = createWith[i];
		let tid = getNavContext(cwType);
		// Missing a necessary has-a, can't create
		if (!tid) {
			base = null;
			break;
		}
		// HACK What's the field name for TypeA's has-a TypeB? (see the java classes)
		let k = keyForType(cwType);
		base[k] = tid;
	}
	// All OK, render the button
	if (base) return <CreateButton type={type} base={base} navpage={navpage}>{children}</CreateButton>;
	// Can't create - tell the user why
	return <p>To create {article(type)} {type}, first pick {article(createWith[0])} {commaList(createWith)}</p>;
}


function DefaultFilterControls() {
	return <PropControl inline label="Filter" prop="filter" type="search" />;
}


export default ListItems;
